import { render, staticRenderFns } from "./JurisdictionChangeTerms.vue?vue&type=template&id=edd36c4c&"
import script from "./JurisdictionChangeTerms.vue?vue&type=script&lang=js&"
export * from "./JurisdictionChangeTerms.vue?vue&type=script&lang=js&"
import style0 from "./JurisdictionChangeTerms.vue?vue&type=style&index=0&id=edd36c4c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../log-in-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports